module.exports = __webpack_public_path__ + "img/simplepay_200x50.ed37e1c7.png";